<template lang="pug">
#filtros.mb-3
    el-collapse(style='border: none')
        el-collapse-item(name='filtros')
            span.titulo(slot='title') Filtros

            el-form.fields(label-position='top', size='mini')
                el-form-item.usuarios
                    label Usuários
                    el-select(
                        v-model='filtros.idsUsuarios',
                        filterable,
                        remote,
                        multiple,
                        reserve-keyword,
                        :remote-method='remoteMethodUsuario',
                        @blur='buscarUsuarios'
                    )
                        el-option(
                            v-for='usuario in usuarioBusca',
                            :key='`${usuario.nome}${usuario.id}`',
                            :label='usuario.name',
                            :value='usuario.id'
                        )
                            | {{ usuario.name }}

                el-form-item.situacao
                    label Situação
                    el-select(v-model='situacaoSelecionada')
                        el-option(
                            v-for='situacao in situacoesPossiveis',
                            :key='situacao',
                            :label='situacao',
                            :value='situacao'
                        )
                            | {{ situacao }}

                el-form-item.solicitacao
                    label Data solicitação
                    .date
                        el-date-picker(
                            v-model='filtros.dataCadastroInicio',
                            type='date',
                            placeholder='Selecione',
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )
                        span à
                        el-date-picker(
                            v-model='filtros.dataCadastroFim',
                            type='date',
                            placeholder='Selecione',
                            style='width: 47%',
                            format='dd/MM/yyyy'
                        )

                el-form-item.actions
                    .buttons
                        el-button.mr-10(
                            icon='el-icon-delete',
                            @click='limparFiltros'
                        ) Limpar
                        el-button(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='criarFiltro'
                        ) Filtrar
</template>

<script>
import UsuarioService from '@/services/UsuarioService';
import SituacaoCompartilhamentoDados from '@/constants/SituacaoCompartilhamentoDados';

const ordem = (a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
    }
    return 0;
};

export default {
    name: 'Filtros',
    emits: ['getFiltrosCompart'],

    data() {
        return {
            listaUsuarios: [],
            situacoesPossiveis: [
                'Em processamento',
                'Falha no processamento',
                'Processado'
            ],
            situacaoSelecionada: '',
            filtros: {
                idsUsuarios: [],
                situacao: null,
                dataCadastroInicio: '',
                dataCadastroFim: ''
            },
            usuarioBusca: []
        };
    },

    created() {
        this.limparFiltros();
    },

    methods: {
        getFiltroCompart() {
            return '';
        },

        remoteMethodUsuario(query) {
            if (query !== '') {
                this.usuarioBusca = this.listaUsuarios.filter(item => {
                    return (
                        item.name.toLowerCase().indexOf(query.toLowerCase()) >
                        -1
                    );
                });
            } else {
                this.usuarioBusca = this.listaUsuarios;
            }
        },

        async buscarUsuarios(query) {
            if (this.listaUsuarios.length) return;
            UsuarioService.buscaTodosSemPaginacaoPorGrupo(
                this.getFiltroCompart(query)
            )
                .then(({ data }) => {
                    this.listaUsuarios = data.sort(ordem);
                    this.usuarioBusca = this.listaUsuarios;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        limparFiltros() {
            this.filtros = {
                idsUsuarios: [],
                situacao: null,
                dataCadastroInicio: '',
                dataCadastroFim: ''
            };
            this.situacaoSelecionada = '';
            this.$emit('getFiltrosCompart', this.filtros);
        },

        criarFiltro() {
            if (this.situacaoSelecionada) {
                this.filtros.situacao = SituacaoCompartilhamentoDados.getByName(
                    this.situacaoSelecionada
                );
            }
            this.$emit('getFiltrosCompart', this.filtros);
        }
    }
};
</script>

<style scoped lang="scss">
#filtros {
    background-color: var(--white);
    width: 100%;
    padding: 0 15px;

    overflow: hidden;
    border-radius: 4px;

    .fields {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-template-areas:
            'usuarios usuarios situacao situacao solicitacao solicitacao'
            'vazio vazio vazio vazio vazio acoes';
        column-gap: 15px;

        .usuarios {
            grid-area: usuarios;
        }
        .situacao {
            grid-area: situacao;
        }
        .solicitacao {
            grid-area: solicitacao;
        }
        .actions {
            grid-area: acoes;
        }
    }

    label {
        margin-bottom: -5px;
    }

    .el-select {
        margin-top: -20px;
        width: 100%;
    }

    .el-date-picker {
        width: 40%;
    }

    .titulo {
        font-size: 14px;
        font-family: 'Roboto', 'sans serif';
    }

    .date {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .actions {
        margin-bottom: 0;

        .buttons {
            display: flex;
            justify-content: flex-end;
            margin-top: 15px;
        }
    }
}
</style>
